import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import DesktopModal from './InfoModal/InfoModal';
import s from './Discount.css';

const isMobile = __APP__ === 'mobile';

class Discount extends React.Component {
  static propTypes = {
    discount: PropTypes.number.isRequired,
    t: PropTypes.func.isRequired,
  };

  state = {
    showModal: false,
  };

  switchModal = e => {
    e.preventDefault();
    this.setState({ showModal: !this.state.showModal });
  };

  render() {
    const { discount, t } = this.props;
    const { showModal } = this.state;

    return (
      <div className={s.root} onClick={this.switchModal}>
        <span className={cx(s.info, { [s.desktopInfo]: !isMobile })}>
          {t('При покупке онлайн')}
        </span>
        <span className={cx(s.info, s.infoPercent)}>-{discount}%</span>
        <DesktopModal isMobile={isMobile} showModal={showModal} switchModal={this.switchModal} />
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(Discount));



// WEBPACK FOOTER //
// ./src/shared/components/Discount/Discount.js